module.exports = __webpack_public_path__ + "static/Certificate_PCI_DSS_LLC_2026-94938c9eaa8b11d4b47e7d6de0871445.pdf";